import { useGetApiService, usePostApiService } from '../use-api-service'
import { AUTH_PATH, LOGOUT_RESOURCE } from '../constants'
import type {
  MessageResponse,
  RegisterPayload,
  VerificationPayload,
  LoginPayload,
  LoginResponse,
  ForgotPayload,
  RecoverPayload,
  GoogleLoginPayload,
  AuthResponse,
  InvitationCreatePayload,
  InvitationValidateResponse,
} from '../types'

export const useOboardingService = () => {
  const register = usePostApiService<RegisterPayload, MessageResponse>(AUTH_PATH, 'signup', false)
  const verification = usePostApiService<VerificationPayload, MessageResponse>(AUTH_PATH, 'verify', false)
  const login = usePostApiService<LoginPayload, LoginResponse>(AUTH_PATH, 'signin', false)
  const recovery = usePostApiService<RecoverPayload, MessageResponse>(AUTH_PATH, 'password-recovery', false)
  const forgot = usePostApiService<ForgotPayload, MessageResponse>(AUTH_PATH, 'forgot-password', false)
  const googleLogin = usePostApiService<GoogleLoginPayload, LoginResponse>(AUTH_PATH, 'google-authentication', false)
  const inviteUser = usePostApiService<InvitationCreatePayload, MessageResponse>(AUTH_PATH, 'invite')
  const validateInvitationCode = useGetApiService<any, InvitationValidateResponse>({
    path: AUTH_PATH,
    resource: 'validate-invitation',
    key: 'validate-invitation',
    withAuth: false,
  })

  return {
    register,
    verification,
    login,
    forgot,
    recovery,
    googleLogin,
    validateInvitationCode,
    inviteUser,
  }
}

export const useAuthService = () => {
  const logout = useGetApiService<any, MessageResponse>({
    path: AUTH_PATH,
    resource: LOGOUT_RESOURCE,
    key: 'logout',
    withAuth: false,
  })
  const checkAuthentication = useGetApiService<any, AuthResponse>({
    path: AUTH_PATH,
    resource: 'check-authentication',
    key: 'check-authentication',
    withAuth: false,
  })

  return { checkAuthentication, logout }
}
